import {lazyComponent} from 'coreUtils/adapters/lazy';

export default lazyComponent(() => import('./CarouselSwiper'));
